import { useContext } from 'react';
import { createNamedContext } from '~/util';

export const DashboardContext = createNamedContext('DashboardContext');

export const useDashboard = () => useContext(DashboardContext);